export function makeElementDraggable(element: JQuery<HTMLElement>): void {
    element.on("mousedown", (event) => {
        const initialX = event.pageX;
        const initialY = event.pageY;
        const initialOffset = element.offset();

        const onMouseMove = (e: JQuery.MouseMoveEvent) => {
            element.offset({
                left: initialOffset.left + e.pageX - initialX,
                top: initialOffset.top + e.pageY - initialY,
            });
        };

        const onMouseUp = () => {
            $("body")
                .off("mouseup", onMouseUp)
                .off("mousemove", onMouseMove)
                .css("cursor", "auto");
        };

        $("body")
            .on("mouseup", onMouseUp)
            .on("mousemove", onMouseMove)
            .css("cursor", "move");

        // Prevents other drag events from triggering
        return false;
    });

    element.find("button, input").mousedown((e) => e.stopImmediatePropagation());
    element.find("button, input").mousemove((e) => e.stopImmediatePropagation());
}
